module.exports = __webpack_public_path__ + "img/loader.4f00fc07.gif";